import { graphql } from 'react-relay';

export const productProviderListItem = graphql`
    fragment productProvider_listItem on ProductProviderListItem {
        id
        name
        imageUrl
    }
`;

export const productProviderProduct = graphql`
    fragment productProvider_product on ProductProviderProduct {
        generalInfo {
            productID
            name
            type
            imageUrl
            brand
            description
            variantsCount
        }
        options {
            optionID
            type
            title
            values {
                key
                value
            }
        }
        variants {
            variantID
            name
            canRotate
            colorCode
            colorName
            isColored
            imageUrl
            inStock
            price
            productId
            size
            availabilityStatus {
                region
                status
            }
        }
        sidesNames {
            key
            value
        }
        sides {
            side
            mandatory
            imageUrl
        }
        conflictingSides {
            side
            conflicts
        }
        errorMessage
        isNotRecolor
    }
`;

export const retailProduct = graphql`
    fragment productProvider_retailProduct on ProductProviderRetailProduct {
        profitPercentage
        variants {
            variantID
            name
            canRotate
            colorCode
            colorName
            isColored
            imageUrl
            inStock
            price
            productId
            size
            availabilityStatus {
                region
                status
            }
        }
    }
`;
